import {IDS} from '../improvement-action-id.constants';
import { IDS as MASTER_DOC_LIST_IDS } from '../../master-doc-list/master-doc-list-action-id.constants';
import {TYPES} from "../improvement-action-type.constants";
import * as Actions from '../improvement.actions';
import * as AccAction from '../../accreditation.actions';
import {GRID_FETCH, GRID_FILTER, GRID_RELOAD} from "../../../../common/grid/grid.constants";
import get from 'lodash/get';
import moment from "moment";
import {formatDate} from "../../../../common/utils/util.date";
import {DATE_FORMAT} from "../../../../common/utils/util.constants";
import watch from "redux-watch";
import pick from "lodash/pick";
import {TAB_SELECT} from "../../../../common/tabs/tabs.constants";
import find from "lodash/find";
import {TYPES as RCO_TYPES} from "../../accreditation-action-type.constants";

class AddActionController {
    constructor($ngRedux,
                $state,
                $stateParams,
                $uiRouterGlobals,
                $filter,
                $timeout,
                $transitions,
                $mdDialog,
                Notifier,
                DocumentManager,
                EmployeeService,
                AuthService,
                FileActions,
                $rootScope,
                $scope) {
        this.$ngRedux = $ngRedux;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$uiRouterGlobals = $uiRouterGlobals;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$transitions = $transitions;
        this.$mdDialog = $mdDialog;
        this.Notifier = Notifier;
        this.DocumentManager = DocumentManager;
        this.EmployeeService = EmployeeService;
        this.AuthService = AuthService;
        this.FileActions = FileActions;
        this.identifier = IDS.rcoImprovement;
        this.statePath = IDS.improvementStep;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
    }

    async $onInit() {
        this.schemeCode = this.$stateParams.itemCode;
        const user = this.AuthService.getUser();
        this.user = user;
        this.userUuid = user.uuid;
        this.userName = user.name;
        this.isAdmin = user.type === 'Administrator';

        this.unsubscribe = this.$ngRedux.connect(state => {
            const accDashboardLocationYear = state.accreditation.accDashboardLocationYear;
            const subModule = state.accreditation.rcoImprovement;
            const requirement = state.accreditation.selectedRequirement;
            // this.maxDueDate = moment(`${maxYear}-01-01`).add(fiscalYearStart, 'months').subtract(1,'days').toDate();
            this.minDueDate = new Date();

            return {
                level1Requirements: subModule.level1Requirements,
                level3Requirements: subModule.level3Requirements,
                level3RequirementId: subModule.level3RequirementId,
                level3RequirementName: subModule.level3RequirementName,
                linkableEvidenceGroups: subModule.linkableEvidenceGroups,
                evidenceGroupId: subModule.evidenceGroupId,
                evidenceGroupName: subModule.evidenceGroupName,
                requirementName: requirement?.name,
                requirementDescription: get(requirement, 'description', '')?.replace(/\n/g, '<br>'),
                fiscalYear: accDashboardLocationYear.year,
                locationName: subModule.selectedSiteLocation?.locationName,
                siteLocationUuid: accDashboardLocationYear.siteLocation,
                headOfficeUuid: accDashboardLocationYear.headOffice,
                requirementsTree: state.accreditation.simpleSectionsTree,
                requirement,
                // selectedAuditTask: this.isAdmin
                //     ? subModule.selectedAuditTask
                //     : subModule.auditors?.find(item => item.assignee_uuid === this.userUuid)?.uta_id,
                documentForRevisionRequest: subModule.documentForRevisionRequest,
                docRevisionRequest: subModule.docRevisionRequest,
                improvementAction: subModule.improvementAction,
                improvementSteps: get(subModule, `${IDS.improvementStepsGrid}.items`, []),
                improvementStep: subModule.improvementStep,
                firstDocType: state.accreditation.common.documentTypes[0].value,
            }
        }, {
            ...AccAction,
            ...Actions,
            ...this.FileActions,
        })(this);

        this.unsubscribeLocationChange = this.$scope.$on('LOCATION_SUBJECT_SELECTED', this.onLocationChange.bind(this));
        // this.unsubscribeSelectCascadeLoaded = this.$scope.$on('SELECT_CASCADE_SUBJECTS_LOADED', this.onSelectCascadeLoaded.bind(this));
        this.unsubscribeLocationNotFound = this.$scope.$on('LOCATION_SUBJECT_NOT_FOUND', this.onLocationNotFound.bind(this));

        const ctrl = this;
        this.$timeout(async () => {
            const { hof, slo } = ctrl.$uiRouterGlobals.params;
            ctrl.paramsSlo = slo;
            ctrl.paramsHof = hof;
            ctrl.selectCascadeBehaviour = ctrl.paramsSlo ? '' : 'selectDefault'; // if site location is not set, select first head office and site location

            let siteLocation;
            let headOffice;
            if(ctrl.isSingleSiteUser()) { // no other site can be selected then user's site
                siteLocation = ctrl.user.parents[0].uuid;
            }
            // take selected site from list
            else if(ctrl.paramsSlo) {
                siteLocation = ctrl.paramsSlo;
            }
            if(siteLocation) {
                const result = await ctrl.EmployeeService.getEmploymentLocations(siteLocation);
                headOffice = result[0] && result[0].uuid;
                if (headOffice) {
                    if (ctrl.isSingleSiteUser()) {
                        ctrl.$rootScope.$broadcast('FORCE_SELECT_PARENT', 0, siteLocation, null);
                    } else {
                        ctrl.$rootScope.$broadcast('FORCE_SELECT_PARENT', 0, headOffice, siteLocation);
                    }
                }
            }
        },200);
        // if(this.$stateParams.due_date) {
        //     this.$ngRedux.dispatch({
        //         type: TYPES.SET_DUE_DATE,
        //         date: new Date(`${this.$stateParams.due_date} 00:00:00`),
        //     });
        // }

        this.$timeout(function() {
            ctrl.fetchAutocompleteUser(
                ctrl.userUuid,
                `${ctrl.identifier}.${IDS.assigneeCandidates}`,
                `${ctrl.identifier}.improvementAction`
            );
            ctrl.$ngRedux.dispatch({
                id: ctrl.identifier,
                type: TYPES.RESET_NEW_STEP_DETAILS,
            });
            ctrl.$ngRedux.dispatch({
                id: ctrl.identifier,
                type: GRID_FETCH,
                path: IDS.improvementStepsGrid,
                items: [],
            })
        }, 200);
    }

    isSingleSiteUser() {
        return this.user.parentCount === 1 && this.user.parents[0].basicType === 'slo';
    }

    async onLocationChange (evt, loc) {
        const subjectType = get(loc,'in_subject_basic_type_code');

        let siteLocation;
        switch(subjectType) {
            case 'hof':
                // if(this.paramsHof && loc.in_subject_uuid !== this.paramsHof) {
                //     return;
                // }
                this.$ngRedux.dispatch({
                    type: RCO_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                    accDashboardLocationYear: {
                        headOffice: loc.in_subject_uuid,
                        siteLocation: null,
                        // year: this.fiscalYear,
                    }
                });
                break;

            case 'slo':
                // if(this.paramsSlo && loc.in_subject_uuid !== this.paramsSlo) {
                //     return;
                // }

                siteLocation = loc.in_subject_uuid;
                this.$ngRedux.dispatch({
                    type: RCO_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                    accDashboardLocationYear: {
                        siteLocation: siteLocation,
                        year: this.fiscalYear,
                    }
                });
                // this.resetAssignees();
                // this.fetchSiteLocationDetails( siteLocation );
                // this.fetchSiteLocationContacts( siteLocation );
                await this.initRequirementsInputSelects(siteLocation);
                this.onResetEvidenceGroup();
                this.onResetLinkableEvidenceGroups();
                break;
        }
    };

    async onLocationNotFound(event, location) {
        if(this.isSingleSiteUser()) {
            const siteLocation = this.user.parents[0].uuid;
            this.fetchSiteLocationContacts(siteLocation);
            await this.initRequirementsInputSelects(siteLocation);
            this.$ngRedux.dispatch({
                type: RCO_TYPES.LOCATION_SEARCH_BAR_CHANGE,
                accDashboardLocationYear: {
                    siteLocation,
                }
            });
        }
    }

    async initRequirementsInputSelects (siteLocation) {
        const skipEmptyNodes = true;
        await this.fetchFrameworkRequirementsTree(this.schemeCode, siteLocation, this.fiscalYear, skipEmptyNodes);
        // insert requirements to first requirement select box
        this.$ngRedux.dispatch({
            type: TYPES.SELECT_NEW_STEP_REQUIREMENT,
            id: this.identifier,
            level:0,
            requirements: this.requirementsTree,
            requirementId: null,
            requirementParentId: null,
        });
        const selectedLevel1Id = get(this.requirementsTree, '[0].id');
        const selectedLevel2Id = get(this.requirementsTree,'[0].children[0].id');
        if(selectedLevel1Id)
            this.onSelectRequirement({item:{value: selectedLevel1Id}});
        if(selectedLevel2Id)
            this.onSelectRequirement({item:{value: selectedLevel2Id}});

        if(this.preselectedRequirement && this.siteLocation){
            this.requirementId = this.preselectedRequirement;
            this.preselectedRequirement = null;
            this.onButtonAssignRequirement()
        }
    }

    onSelectRequirement({item}){
        const requirement = this.findChildRequirementById(item.value, this.requirementsTree);
        this.$ngRedux.dispatch({
            type:               TYPES.SELECT_NEW_STEP_REQUIREMENT,
            id:                 this.identifier,
            level:              requirement.level,
            requirements:       requirement.children,
            name:               requirement.name,
            requirementId:      requirement.id,
            requirementParentId:requirement.parentId,
        });
        if(requirement.level === 3) {
            this.fetchRequirementEvidenceGroups(requirement.id, this.siteLocationUuid, this.schemeCode);
        }
    }

    findChildRequirementById(id, requirements) {
        return requirements.reduce((result, item) => {
            if(result)
                return result;
            if(item.id === id)
                return item
            else if (item.children.length)
                return this.findChildRequirementById(id, item.children)
        }, null);
    }

    onResetRequirement() {
        this.$ngRedux.dispatch({
            id: this.identifier,
            type: TYPES.RESET_REQUIREMENT
        });
        this.onResetEvidenceGroup();
        this.onResetLinkableEvidenceGroups();
    }

    onResetEvidenceGroup() {
        this.$ngRedux.dispatch({
            id: this.identifier,
            type: TYPES.RESET_SELECTED_EVIDENCE_GROUP
        });
    }

    onResetLinkableEvidenceGroups() {
        this.$ngRedux.dispatch({
            id: this.identifier,
            type: TYPES.RESET_LINKABLE_EVIDENCE_GROUPS
        });
    }

    async onAutocompleteKeywordQuery (keyword) {
        return await this.fetchEmployeesAndManagers(
            keyword,
            this.siteLocationUuid,
            `${this.identifier}.${IDS.assigneeCandidates}`,
        );
    }

    onAddImprovementStep = () => {
        // verify limit of 100 steps is not reached
        if (this.improvementSteps.length === 100)
            return

        const form = this.$scope.actionStepForm;

        // verify fields
        if(!form.$valid) {
            for (const item of form.$$controls) {
                if (item.$invalid) {
                    item.$setTouched();
                }
            }
            this.Notifier.error('Please fill in the form fields');
            return;
        }

        // verify that title is unique
        if(this.improvementSteps.some(step => step.title === this.improvementStep.title)) {
            this.Notifier.error('Action task title already exists');
            return;
        }

        this.$ngRedux.dispatch({
            type: GRID_FETCH,
            id: this.identifier,
            path: IDS.improvementStepsGrid,
            items: [
                {
                    task_number:    '***',
                    assignee:       this.improvementStep.assignee.name,
                    assignee_uuid:  this.improvementStep.assignee.subject_uuid,
                    title:          this.improvementStep.title,
                    description:    this.improvementStep.description,
                    requirement_id: this.level3RequirementId,
                    requirement_name: this.level3RequirementName || '-',
                    evidence_id:    this.evidenceGroupId,
                    evidence_name:  this.evidenceGroupName || '-',
                    due_date:       formatDate(this.improvementStep.due_date, DATE_FORMAT.OUTPUT),
                    status_name:    'Not Saved',
                },
                ...this.improvementSteps
            ],
        });
        this.$ngRedux.dispatch({
            id: this.identifier,
            type: TYPES.RESET_NEW_STEP_DETAILS,
        });
        this.$ngRedux.dispatch({
            id: this.identifier,
            type: TYPES.RESET_REQUIREMENT,
        });

        form.$setPristine();
        form.$setUntouched();
        form.action_task_title.$setPristine();
        form.action_task_title.$setUntouched();
        form.action_task_description.$setPristine();
        form.action_task_description.$setUntouched();
        form.action_task_date.$setPristine();
        form.action_task_date.$setUntouched();
        form.assigneeCandidateAutocomplete.$setPristine();
        form.assigneeCandidateAutocomplete.$setUntouched();
        window.scrollTo(0, document.body.scrollHeight);
    }

    onGridButtonRemoveTask = ({item}) => {
        this.$ngRedux.dispatch({
            type: GRID_FETCH,
            id: this.identifier,
            path: IDS.improvementStepsGrid,
            items: [...this.improvementSteps.filter(step => step !== item)]
        })
    }

    // onSelectImprovementStep = ({item}) => {
    //     this.$ngRedux.dispatch({
    //         id: this.identifier,
    //         type: TYPES.SET_IMPROVEMENT_STEP_DIALOG,
    //         details: item
    //     });
    //     const dialogController = ($scope) => {
    //         $scope.identifier = this.identifier;
    //         $scope.onAutocompleteKeywordQuery = async (event) => await this.onAutocompleteKeywordQuery(event);
    //         $scope.submit = () => {
    //             if ($scope.improvementStepDialogForm.$valid) {
    //                 this.$ngRedux.dispatch({
    //                     id: $scope.identifier,
    //                     type: TYPES.UPDATE_IMPROVEMENT_STEP,
    //                 });
    //                 this.$mdDialog.hide();
    //             }
    //         };
    //         $scope.cancel = () => {
    //             this.$mdDialog.cancel();
    //         };
    //     };
    //     dialogController.$inject = ['$scope'];
    //
    //     this.dialog = this.$mdDialog.show({
    //         controller: dialogController,
    //         template: require('./evidence-group-improvement-step-dialog.html'),
    //         parent: angular.element(document.body),
    //         clickOutsideToClose: true
    //     }).then(this.resetImprovementStepDialog, this.resetImprovementStepDialog);
    // }

    // resetImprovementStepDialog = () => {
    //     this.$ngRedux.dispatch({
    //         id: this.identifier,
    //         type: TYPES.SET_IMPROVEMENT_STEP_DIALOG,
    //         details: {}
    //     });
    // };


    onSubmit() {
        const form = this.$scope.actionForm;
        if(form.$invalid) {
            this.Notifier.error('COMMON.FIELDS_REQUIRED');
            for (const item of form.$$controls) {
                if (item.$invalid) {
                    item.$setTouched();
                }
            }
            return;
        }

        if(!this.improvementSteps?.length) {
            this.Notifier.error('Please add at least one task');
            return;
        }
        this.addImprovementAction({
            // vdo_uuid: this.documentForRevisionRequest?.id || this.improvementAction?.vdo_uuid,
            framework:          this.schemeCode,
            slo_uuid:           this.siteLocationUuid,
            // audit_task:         this.selectedAuditTask,
            assignee:           this.improvementAction?.assignee.subject_uuid,
            title:              this.improvementAction?.title,
            description:        this.improvementAction?.description,
            due_date:           formatDate(this.improvementAction?.dueDate, DATE_FORMAT.OUTPUT),
            action_steps:       this.improvementSteps.map(step => ({
                assignee:       step.assignee_uuid,
                title:          step.title,
                description:    step.description,
                requirement_id: step.requirement_id,
                evidence_id:    step.evidence_id,
                due_date:       formatDate(step.due_date, DATE_FORMAT.OUTPUT),
            })),
        }).then(() => {
            // this.$ngRedux.dispatch({
            //     type: TAB_SELECT,
            //     id: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups,
            //     state: IDS.app_accreditation_scheme_requirements_assessment_evidence_groups_list,
            // });

            this.$ngRedux.dispatch({
                type: GRID_FETCH,
                id: this.identifier,
                path: IDS.improvementStepsGrid,
                items: [],
            });
            this.$ngRedux.dispatch({
                id: this.identifier,
                type: TYPES.SET_IMPROVEMENT_ACTION_DETAILS,
                details: {}
            });
            form.$setPristine();
            form.$setUntouched();
        });
    }

    reloadDetailsAndStatuses() {
        const requirementId = this.requirement?.id;
        const siteLocationUuid = this.siteLocationUuid;
        const year = this.fiscalYear;
        this.fetchRequirementAuditorStatuses(requirementId, siteLocationUuid, year, this.userUuid, this.improvementAction.evidenceGroupId);
        this.fetchEvidenceGroupsProgressGrid({requirementId, siteLocationUuid, year}).then(() => {
            this.$ngRedux.dispatch({
                type: TYPES.SELECT_EVIDENCE_DETAILS,
                ardId: this.improvementAction.evidenceGroupId,
                firstDocType: this.firstDocType,
            });

//         const ctrl = this;
//         this.fetchAssessmentRequirementsTreeProgress(this.schemeCode, this.siteLocationUuid, year).then((data) => {
//             ctrl.selectRequirementById(requirementId);
//
//             this.$ngRedux.dispatch({
//                 type: GRID_RELOAD,
//                 id: IDS.rcoRequirementsAssessment,
//                 path: IDS.rcoEvidenceGroupsProgressGrid,
//             });
//         });
        });
    }

    onBack() {
        this.$ngRedux.dispatch({
            type: TAB_SELECT,
            id: IDS.app_accreditation_scheme_improvement,
            state: IDS.app_accreditation_scheme_improvement_list,
        });
    }

    $onDestroy() {
        if(this.unsubscribe)
            this.unsubscribe();
        if(this.unsubscribeLocationChange)
            this.unsubscribeLocationChange();
        if(this.unsubscribeLocationNotFound)
            this.unsubscribeLocationNotFound();
    }
}

AddActionController.$inject = [
    '$ngRedux',
    '$state',
    '$stateParams',
    '$uiRouterGlobals',
    '$filter',
    '$timeout',
    '$transitions',
    '$mdDialog',
    'Notifier',
    'DocumentManager',
    'EmployeeService',
    'AuthService',
    'FileActions',
    '$rootScope',
    '$scope']

export const addAction = {
    controller: AddActionController,
    template: `
    <div>
        <div style="margin: 10px 0 5px 0;">
            <tabs-header title="Add Improvement Action"></tabs-header>
            <md-subheader class="md-no-sticky">Improvement Action</md-subheader>
        </div>
        <div layout="row" flex style="margin: 0 20px 10px 20px">
            <div layout-gt-xs="column" style="min-width:200px">
                <div class="accreditation-table-item md-body-1">Type:</div>
            </div>
            <span flex="5"></span>
            <div layout-gt-xs="column">
                <div class="accreditation-table-item md-body-1">Corrective</div>
            </div>
        </div>
        <div layout="column" flex>
            <form id="selectSiteLocationForm" name="$ctrl.selectSiteLocationForm" novalidate>
                <div flex layout-gt-sm="row">
                    <div layout-gt-sm="row">
                        <select-cascade
                                identifier="{{$ctrl.identifier}}"
                                state-path="{{$ctrl.statePath}}"
                                purpose="'acc'"
                                behaviour="$ctrl.selectCascadeBehaviour"
                                show-single-parent="true"
                                max="slo"
                                scheme="{{$ctrl.$stateParams.itemCode}}">
                        </select-cascade>
                    </div>
                </div>
            </form>
        </div>
        <div layout="column" class="eventsTransparent" style="margin-bottom: 40px;">
            <h4>Improvement Action Details</h4>
            <ng-form name="actionForm" style="margin: 10px" >
                <div layout-gt-xs="row">
                    <asset cls="input-icon" style="margin-top: 18px" src="action-task.svg"></asset>
                    <input-text flex
                                class="noMarginBottom"
                                name="improvementTitle"
                                label="Title (improvement intent)"
                                identifier="{{$ctrl.identifier}}"
                                state-path="improvementAction.title"
                                required="true"
                                max-length="120">
                    </input-text>
                </div>
                <div layout-gt-xs="row">
                    <input-text-area flex
                                     class="noMarginBottom"
                                     name="improvementRootCause"
                                     rows="3"
                                     label="Description (Root Cause)"
                                     identifier="{{$ctrl.identifier}}"
                                     state-path="improvementAction.description"
                                     required="true"
                                     max-length="1000">
                    </input-text-area>
                </div>
                <div layout-gt-md="row">
<!--                    <md-subheader class="md-no-sticky" style="margin-top: 20px">Improvement assignee</md-subheader>-->
                    <asset cls="input-icon" style="margin-top: 15px" src="user.svg"></asset>
                    <autocomplete flex
                                  name="actionAssigneeAutocomplete"
                                  label="Approver Of Action Tasks"
                                  identifier="{{$ctrl.identifier}}"
                                  action="$ctrl.onAutocompleteKeywordQuery($event)"
                                  state-provider="assigneeCandidates"
                                  state-path="improvementAction.assignee"
                                  validate="true"
                                  required="true"
                                  item-icon="user.svg"
                                  item-props="['name']">
                    </autocomplete>
                    <input-date name="improvementDueDate"
                                flex-gt-md="20"
                                class="noMarginBottom"
                                label="Improvement Due Date"
                                identifier="{{$ctrl.identifier}}"
                                state-path="improvementAction.dueDate"
                                min-date="$ctrl.minDueDate"
                                max-date="$ctrl.maxDueDate"
                                validate="true"
                                required="true">
                    </input-date>
                </div>
            </ng-form>
        </div>
        
        <div layout-margin></div>
        <div layout="column" class="eventsTransparent" style="margin-bottom: 40px;">
            <ng-form name="actionStepForm">
                <h4>Add Action Task</h4>
                <div layout-gt-xs="row">
                    <div layout="row" flex>
                        <asset cls="input-icon" style="margin-top: 18px" src="action-task.svg"></asset>
                        <input-text flex label="Action Task Title"
                                    class="noMarginBottom"
                                    name="action_task_title"
                                    max-length="120"
                                    identifier="{{$ctrl.identifier}}"
                                    state-path="improvementStep.title"
                                    validate="true"
                                    required="true">
                        </input-text>
                    </div>
<!--                            <input-text flex-gt-sm="20"-->
<!--                                        class="noMarginBottom"-->
<!--                                        name="action_task_id"-->
<!--                                        label="Action Task ID No."-->
<!--                                        identifier="{{$ctrl.identifier}}"-->
<!--                                        state-path="action_task_print_id"-->
<!--                                        disabled="true">-->
<!--                            </input-text>-->
                </div>
                <div layout-gt-xs="row">
                    <input-text-area flex
                                     class="noMarginBottom"
                                     name="action_task_description"
                                     rows="3"
                                     max-length="1000"
                                     label="Details of Action Task"
                                     identifier="{{$ctrl.identifier}}"
                                     state-path="improvementStep.description"
                                     validate="true"
                                     required="true">
                    </input-text-area>
                </div>
                <div layout-gt-xs="row">
                    <asset cls="input-icon" style="margin-top: 18px" src="user.svg"></asset>
                    <autocomplete flex
                                  name="assigneeCandidateAutocomplete"
                                  label="Action Task Assignee"
                                  identifier="{{$ctrl.identifier}}"
                                  action="$ctrl.onAutocompleteKeywordQuery($event)"
                                  state-provider="assigneeCandidates"
                                  state-path="improvementStep.assignee"
                                  validate="true"
                                  required="true"
                                  item-icon="user.svg"
                                  item-props="['name']">
                    </autocomplete>
                    <input-date name="action_task_date"
                                class="noMarginBottom"
                                label="Due Date"
                                identifier="{{$ctrl.identifier}}"
                                state-path="improvementStep.due_date"
                                min-date="$ctrl.minDueDate"
                                max-date="$ctrl.maxDueDate"
                                validate="true"
                                required="true">
                    </input-date>
                </div>
                <div layout="row">
                    <div style="margin-top: 25px; margin-right: 20px">
                        <span class="formTitle">Linked Requirement</span>
                    </div>
                    <asset cls="input-icon" style="margin-top: 15px" src="search.svg"></asset>
                    <div layout-gt-lg="row" flex>
                        <input-select flex label="Level 1 {{ 'ACCREDITATION.COMMON.REQUIREMENT' | translate}}"
                                      identifier="{{$ctrl.identifier}}"
                                      disabled="!$ctrl.level1Requirements.length > 0"
                                      state-path="level1RequirementId"
                                      state-data="level1Requirements"
                                      on-change="$ctrl.onSelectRequirement($event)"
                                      select-first-item="true">
                        </input-select>
                        <input-select flex label="Level 2 {{ 'ACCREDITATION.COMMON.REQUIREMENT' | translate}}"
                                      identifier="{{$ctrl.identifier}}"
                                      disabled="!$ctrl.level1Requirements.length > 0"
                                      state-path="level2RequirementId"
                                      state-data="level2Requirements"
                                      on-change="$ctrl.onSelectRequirement($event)"
                                      select-first-item="true">
                        </input-select>
                        <input-select flex label="Level 3 {{ 'ACCREDITATION.COMMON.REQUIREMENT' | translate}}"
                                      disabled="!$ctrl.level3Requirements.length > 0"
                                      identifier="{{$ctrl.identifier}}"
                                      state-path="level3RequirementId"
                                      state-data="level3Requirements"
                                      on-change="$ctrl.onSelectRequirement($event)"
                                      preselect="true">
                        </input-select>
                    </div>
                    <md-button class="btnDefault" style="margin-top: 20px" 
                        ng-click="$ctrl.onResetRequirement()">Reset
                    </md-button>
                </div>
                <div layout="row">
                    <div style="margin-top: 25px; margin-right: 20px">
                        <span class="formTitle">Linked Evidence</span>
                    </div>
                    <asset cls="input-icon" style="margin-top: 15px" src="search.svg"></asset>
                    <div layout-gt-lg="row" flex>
                        <input-select flex label="{{!$ctrl.level3RequirementId ? 'First Select Requirement' : 'Linked Evidence'}}" style="margin-top: 0px;"
                                      disabled="$ctrl.linkableEvidenceGroups.length === 0"
                                      identifier="{{$ctrl.identifier}}"
                                      state-path="evidenceGroupId"
                                      state-data="linkableEvidenceGroups"
                                      on-change="$ctrl.onSelectEvidenceGroup($event)"
                                      preselect="true">
                        </input-select>
                    </div>
                    <md-button class="btnDefault" style="margin-top: 20px" ng-click="$ctrl.onResetEvidenceGroup()">Reset</md-button>
                </div>
                <div layout-xs="column" layout-sm="column" layout-gt-sm="row" flex layout-align="center center">
<!--                            <input-checkbox module="events"-->
<!--                                            identifier="{{$ctrl.identifier}}"-->
<!--                                            state-path="save_task_to_library"-->
<!--                                            label="Save to Action Task Library">-->
<!--                            </input-checkbox>-->
                    <div flex hide-xs hide-sm></div>
<!--                            <md-button class="btnDefault" name="btnActionTaskLibrary" aria-label="Action Task Library" ng-click="$ctrl.openActionTaskLibrary()">-->
<!--                                Action Task Library-->
<!--                            </md-button>-->
<!--                            <md-button class="btnDefault" name="btnActionTask" aria-label="Preselect Action Task" ng-click="$ctrl.selectActionTask()">-->
<!--                                Preselect Action Task-->
<!--                            </md-button>-->
                    <md-button
                        class="btnDefault btnColorAccreditations"
                        name="btnAddActionTask"
                        aria-label="Add Action Task"
                        ng-click="$ctrl.onAddImprovementStep()">Add Action Task
                    </md-button>
                </div>
            </ng-form>
        </div>
<!--            <div style="margin: 10px 0 5px 0;">-->
<!--                <h4>-->
<!--                    <div layout="row" layout-align="start center">-->
<!--                        <div style="padding-left: 5px;">Action Plan</div>-->
<!--                    </div>-->
<!--                </h4>-->
<!--            </div>-->
        <add-action-steps-grid
            on-remove="$ctrl.onGridButtonRemoveTask($event)">
        </add-action-steps-grid>
        <div layout-xs="column" layout-gt-xs="row" layout-align="center center" class="tabs">
            <div flex></div>
            <md-button class="btnTabsNav"
                       name="cancel"
                       aria-label="Cancel"
                       ng-click="$ctrl.onBack()">
                <asset src="arrow_left.svg"></asset>BACK
            </md-button>
            <button type="submit"
                    class="md-button btnColorAccreditations"
                    aria-label="Request Document Revision"
                    ng-click="$ctrl.onSubmit()">Submit Improvement
            </button>
        </div>
    </div>
    `
}
